// extracted by mini-css-extract-plugin
module.exports = {"content":"activityList_content__yGVDZ","list":"activityList_list__PIrI2","config":"activityList_config__6zXn9","newEvent":"activityList_newEvent__0C2uM"};